import RightsBlock from './RightsBlock';

globalThis.RightsBlockComponents = {
  RightsBlock,
};
